import { Component, Input, OnInit } from '@angular/core';
import { ApiV1Review } from '@bluecrew/crew-member-backend-angular-client';

@Component({
  selector: 'app-single-review',
  templateUrl: './single-review.component.html',
  styleUrls: ['./single-review.component.scss'],
})
export class SingleReviewComponent {

  @Input() review: ApiV1Review;

  getNumStars(): number {
    return Math.round(this.review.starRating);
  }

}
